/** Currencies allowed on organization create/edit (pricing & checkout). */
export const ORGANIZATION_FORM_CURRENCIES = [
  { code: 'NGN', label: 'Nigerian Naira (NGN)' },
  { code: 'USD', label: 'US Dollar (USD)' },
  { code: 'GBP', label: 'British Pound (GBP)' },
  { code: 'EUR', label: 'Euro (EUR)' },
]

/** @type {{ code: string; label: string }[]} */
export const CURRENCIES = [
  ...ORGANIZATION_FORM_CURRENCIES,
  { code: 'CAD', label: 'Canadian Dollar (CAD)' },
  { code: 'GHS', label: 'Ghanaian Cedi (GHS)' },
  { code: 'KES', label: 'Kenyan Shilling (KES)' },
  { code: 'ZAR', label: 'South African Rand (ZAR)' },
]

export function getCurrencyLabel(code: string | null | undefined): string {
  if (!code) return '—'
  return CURRENCIES.find((c) => c.code === code)?.label ?? code
}
